module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE1IDEyIj4KICAgIDxwYXRoIGZpbGw9IiMxNENEMTgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUgMTJMMCA3bDItMiAzIDMgOC04IDIgMnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/greenCheck.svg
// module id = QgPI
// module chunks = 47